<!--
 * @Descripttion:
 * @version: 0.0.1
 * @Author: ZHJI
 * @Date: 2019-10-25 09:34:00
 * @LastEditors: ZHJI
 * @LastEditTime: 2019-11-20 16:04:27
 -->
<!--  -->
<template>
  <div class="resourseSelect">
    <el-tag
    v-if="result"
        :closable="!this.disabled"
        size="medium"
        :disable-transitions="true"
        @close="handleClose()">
        {{result.description}}
    </el-tag>
    <el-button :disabled="this.disabled" icon="el-icon-plus"  circle class="button-new-tag" size="small" @click="addRole" />

  <!-- 选择弹窗 -->
  <el-dialog title="资源选择器"  class="avue-dialog no-el-dialog__body__padding"    :visible.sync="modeShow" width="80%"  top="2vh" :append-to-body="true">
      <ResourceSelectInner ref="ResourceChoose" :appKeys="appKey" />
    <div class="avue-form__menu avue-form__menu--center" slot="footer" >
          <el-button type="primary" @click="sure">确 定</el-button>
        <el-button type="info" @click="modeShow =false">取 消</el-button>
    </div>
  </el-dialog>

  </div>
</template>

<script>
export default {
  components: { ResourceSelectInner: () => import('./internalComponents/resourceSelectInner') },
  model: {
    prop: 'value',
    event: 'up'
  },
  props: {
    value: {
      default: () => null
    },
    appKey: {
      default: () => null
    },
    disabled: {

    }
  },
  data() {
    return {
      result: this.value,
      modeShow: false
    }
  },

  methods: {
    handleClose(tag) {
      if (this.disabled) {
        return
      }
      this.result = null
      this.$emit('change')
      this.$emit('up', null)
    },
    addRole: function() {
      if (this.disabled) {
        return
      }
      if (this.appKey) {
        this.modeShow = true
        this.$nextTick(() => {
          setTimeout(() => {
            this.$refs.ResourceChoose.reset()
          }, 30)
        })
      } else {
        this.$message.error('系统错误,appKey丢失')
      }
    },
    sure: function() {
      let data = this.$refs.ResourceChoose.getSelectedRows()
      if (data && data.length) {
        if (data.length !== 1) {
          return this.$message.error('资源选择器只可选择一个资源')
        }
        this.result = data[0]
        this.$emit('up', this.result)
        this.$emit('change')
        this.modeShow = false
      } else {
        this.result = null
        this.$emit('up', null)
        this.$emit('change')
        this.modeShow = false
      }
    }

  }
}

</script>
<style lang="scss">

.resourseSelect{
  .el-tag {
    margin-left: 0.625rem;
  }
  .button-new-tag {
    margin-left: 0.625rem;
    height: 2rem;
    line-height: 1.875rem;
    padding-top: 0;
    padding-bottom: 0;
  }
}
</style>
<style lang='scss' scoped>
.resourseSelect{
    font-size: 0.875rem;
    width: 100%;
    overflow: hidden;
    border-radius:5px;
    background-color:transparent;
    border:1px solid #DCDFE6;
}
</style>
